<template>
    <ModalBase
        :name="name"
        title="Descargar informe"
        @close="$emit('close')"
    >
        <form @submit.prevent="submit">
            <div class="tw:flex tw:flex-col tw:gap-5">
                <BaseMultiselect
                    v-model="formato"
                    label="Formato"
                    name="formato"
                    :options="formatos"
                    value-key="id"
                    label-key="name"
                />

                <BaseDateInput
                    v-model="fecha_inicio"
                    label="Fecha de inicio"
                    name="fecha_inicio"
                />

                <BaseDateInput
                    v-model="fecha_fin"
                    label="Fecha de fin"
                    name="fecha_fin"
                />
            </div>
        </form>

        <template #footer>
            <Button
                :loading="submitting"
                :disabled="submitting"
                @click="submit"
            >
                DESCARGAR
            </Button>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref } from 'vue'
    import store from '@/store'
    import { config } from '@/config.js'
    import { useToast } from '@/composables/common/useToast'

    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue'
    import BaseDateInput from '@/modules/admin/ui/BaseDateInput.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        name: { type: String, required: true },
        ruta: { type: String, default: 'back.bases.informe' },
        detalle: { type: Boolean, default: false },
        lista_id: { type: [Number, String], default: null }
    })

    const emit = defineEmits(['close'])
    const toast = useToast()

    const submitting = ref(false)
    const formato = ref('xls')
    const fecha_inicio = ref('')
    const fecha_fin = ref('')

    const formatos = [
        { id: 'xls', name: 'XLS' },
        { id: 'pdf', name: 'PDF' }
    ]

    async function submit() {
        submitting.value = true

        const params = {
            filters: {
                fecha_inicio: fecha_inicio.value,
                fecha_fin: fecha_fin.value,
                lista_id: props.lista_id,
                formato: formato.value,
                detalle: props.detalle,
                format: formato.value === 'xls' ? 'csv' : 'pdf'
            },
            lista_id: props.lista_id
        }

        try {
            await store.dispatch(
                config.getVuexAlias(props.ruta),
                params
            )
            toast.success('Informe solicitado correctamente. Recibirás una notificación cuando esté listo.')
            emit('close')
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Error al solicitar el informe')
        } finally {
            submitting.value = false
        }
    }
</script>
